import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import { CloseDialogIcon } from '@client/components/shared/SvgIcons';
import styles from './styles.scss';

export class Dialog extends Component {
    static propTypes = {
        children: PropTypes.object.isRequired,
        isShown: PropTypes.bool.isRequired,
        title: PropTypes.string,
        size: PropTypes.string,
        simpleDialog: PropTypes.bool,
        showCloseIcon: PropTypes.bool,
        mobileFullScreenDialog: PropTypes.bool,
        closeDialog: PropTypes.func,
        theme: PropTypes.string,
        isAdventVideoOverlay: PropTypes.bool,
        wrapperNoPadding: PropTypes.bool,
    };

    static defaultProps = {
        simpleDialog: false,
        showCloseIcon: false,
        mobileFullScreenDialog: false,
        wrapperNoPadding: false,
    };

    render() {
        const {
            size,
            children,
            title,
            isShown,
            closeDialog,
            simpleDialog,
            mobileFullScreenDialog,
            showCloseIcon,
            theme,
            isAdventVideoOverlay,
            wrapperNoPadding,
        } = this.props;

        const showTitle = typeof title !== 'undefined';

        return (
            <TransitionGroup>
                {isShown && (
                    <CSSTransition
                        classNames="dialog"
                        timeout={{ enter: 500, exit: 500 }}
                    >
                        <div
                            key="dialog"
                            styleName={classNames('backdrop', theme, {
                                'backdrop--full-screen': mobileFullScreenDialog,
                            })}
                            onClick={simpleDialog ? closeDialog : null}
                        >
                            <div
                                styleName={classNames('wrapper', size, theme, {
                                    'wrapper--full-screen': mobileFullScreenDialog,
                                    'wrapper--adventVideoOverlay': isAdventVideoOverlay,
                                    'wrapper--no-padding': wrapperNoPadding,
                                })}
                                onClick={this.containerClick}
                            >
                                {(showTitle || (simpleDialog && showCloseIcon)) && (
                                    <div styleName="header">
                                        {title && (
                                            <h4 styleName="title">{title}</h4>
                                        )}
                                        {simpleDialog && showCloseIcon && (
                                            <div
                                                styleName="close-wrapper"
                                                onClick={closeDialog}
                                            >
                                                <CloseDialogIcon styleName="close-icon" />
                                            </div>
                                        )}
                                    </div>
                                )}
                                <div styleName={classNames('content', theme)}>
                                    {children}
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                )}
            </TransitionGroup>
        );
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isShown) {
            window.addEventListener('keydown', this.closeDialogWithEscape);
            document.body.classList.add('overflow--hidden');
        }
        else {
            document.body.classList.remove('overflow--hidden');
            window.removeEventListener('keydown', this.closeDialogWithEscape);
        }
    }

    closeDialogWithEscape = event => {
        if (
            event.keyCode === 27 &&
            this.props.simpleDialog &&
            this.props.isShown
        ) {
            this.props.closeDialog();
        }
    };

    containerClick(e) {
        e.stopPropagation();
    }
}

export default CSSModules(Dialog, styles, { allowMultiple: true });
